export default __webpack_public_path__ + "static/media/Minicard_6c.50f73998.svg";